import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=10ae6b22&scoped=true"
import script from "./PostTable.vue?vue&type=script&lang=js"
export * from "./PostTable.vue?vue&type=script&lang=js"
import style0 from "./PostTable.vue?vue&type=style&index=0&id=10ae6b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae6b22",
  null
  
)

export default component.exports